import styled from "styled-components";
import LOGO_SVG from "../../images/logo.svg";
import { useNavigate } from "react-router-dom";
import useHeader from "../../hooks/common/useHeader";
import BURGER_SVG from "../../images/burger.svg";
import MobileHeaderContentView from "./MobileHeaderContentView";

function Header(){
    const navigate = useNavigate();
    const {toggle, name, isBurgerClicked, onBurgerClickHandler, onCloseClickHandler} = useHeader();
    return(
        <Container toggle={toggle}>
            <MobileHeaderContentView onCancelClickHandler={onCloseClickHandler} isOpen={isBurgerClicked}/>
            <div className="inner">
                <Logo src={LOGO_SVG} alt="logo" onClick={() => navigate("/")}/>
                <ButtonBurger src={BURGER_SVG} alt="button_burger" onClick={onBurgerClickHandler}/>
                <Content>
                    <Menu>
                        <MenuItem onClick={() => navigate("/")}>서비스 소개</MenuItem>
                        <MenuItem onClick={() => navigate("/instructor")}>강사 소개</MenuItem>
                        <MenuItem onClick={() => navigate("/board")}>Q&A</MenuItem>
                    </Menu>
                    <AuthorizationMenu>
                        <MenuItem onClick={name ? () => navigate("/profile") : () => navigate("/login")}>{name ? `${name} 님` : "로그인"}</MenuItem>
                        <MenuItem onClick={name ? () => navigate("/cart") : () => navigate("/register")}>{name ? "장바구니" : "회원가입"}</MenuItem>
                    </AuthorizationMenu>
                </Content>
            </div>
        </Container>
    )
}

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 100;
    padding: 20px 0px;
    transition: 0.5s;
    box-shadow: ${(props) => props.toggle ==="true" ? "0px 4px 15px 0px rgba(16, 17, 55, 0.25)" : "none"};
    .inner{
        display: flex;
        align-items: center;
        gap: 120px;
        justify-content: space-between;
    }
`

const Logo = styled.img`
    width: 70px;
    cursor: pointer;
`

const ButtonBurger = styled.img`
    display: none;
    @media (max-width: 600px) {
        display: inline-block;
    }
`

const Content = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;
    @media (max-width: 600px) {
        display: none;
    }
`

const Menu = styled.div`
    gap: 90px;
    display: flex;
    align-items: center;
    @media (max-width: 900px) {
        gap: 60px;
    }
    @media (max-width: 700px) {
        gap: 30px;
    }
`

const MenuItem = styled.div`
    font-size: 15px;
    cursor: pointer;
`

const AuthorizationMenu = styled.div`
    display: flex;
    align-items: center;
    gap: 36px;
`


export default Header;